var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "map-tool",
      class: "elevation-5",
      attrs: { id: "view-type-button" },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      !_vm.viewIsAerial
        ? _c("SatelliteSVG", { staticClass: "mapTypePickerSVG" })
        : _c("MapSVG", { staticClass: "mapTypePickerSVG" }),
      _vm._v(" "),
      _c(
        "md-tooltip",
        { staticClass: "app-tooltip", attrs: { "md-direction": "bottom" } },
        [_vm._v("\n    " + _vm._s(_vm.$t("ChangeViewType")) + "\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dca07bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dca07bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Atoms/ChangeMapTypeButton.vue
// module id = null
// module chunks = 